export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: '主控版',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },     
     
      {
        _name: 'CSidebarNavDropdown',
        name: '營運單位模組',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: '部門資料設定',
            to: '/Operations/Department',
            icon: 'cil-puzzle'
          },  
          {
            name: '人員資料設定',
            to: '/Operations/Users',
            icon: 'cil-puzzle'
          },  
          {
            name: '企業用戶類別',
            to: '/Operations/EnterpriseType',
            icon: 'cil-puzzle'
          }, 
          {
            name: '企業用戶資料',
            to: '/Operations/EnterpriseData',
            icon: 'cil-puzzle'
          }, 
        ]
      },
      
      {
        _name: 'CSidebarNavDropdown',
        name: '標籤作業模組',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: '倉庫資料設定',
            to: '/Label/StorehouseDataSet',
            icon: 'cil-puzzle'
          },  
          {
            name: '生產單位設定',        
            to: '/Label/ProductionUnitSet',
            icon: 'cil-puzzle'
          },  
          {
            name: '標籤款式資料設定',
            to: '/Label/ShapeDataSet',
            icon: 'cil-puzzle'
          },  
          {
            name: '標籤狀態清單設定',
            to: '/Label/StatusListSet',
            icon: 'cil-puzzle'
          },  
          {
            name: '標籤訂購單',
            to: '/Label/Order',
            icon: 'cil-puzzle'
          },  
          {
            name: '標籤生產單',
            to: '/Label/Production',
            icon: 'cil-puzzle'
          },  
          {
            name: '標籤入庫單',
            to: '/Label/StockIn',
            icon: 'cil-puzzle'
          }, 
          {
            name: '生產作廢單',
            to: '/Label/ProductionInvalid',
            icon: 'cil-puzzle'
          }, 
          {
            name: '標籤出貨單',
            to: '/Label/Ship',
            icon: 'cil-puzzle'
          },
          {
            name: '標籤作業查詢',
            to: '/Label/Search',
            icon: 'cil-puzzle'
          },
          /*{
            name: '標籤退貨入庫單',
            to: '/Label/ReturnStockIn',
            icon: 'cil-puzzle'
          },
          {
            name: '倉庫調撥單',
            to: '/Label/TransferOrder',
            icon: 'cil-puzzle'
          },
          {
            name: '標籤序號異動作業',
            to: '/Label/SerialChange',
            icon: 'cil-puzzle'
          },
          {
            name: '標籤批次異動作業',
            to: '/Label/BatchChange',
            icon: 'cil-puzzle'
          },
          {
            name: '標籤狀態查詢',
            to: '/Label/Status',
            icon: 'cil-puzzle'
          },*/
        ]
      },
    
      {
        _name: 'CSidebarNavDropdown',
        name: 'App管理模組',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'App訊息管理',
            to: '/App/Message',
            icon: 'cil-puzzle'
          },  
          {
            name: 'App相機管理',
            to: '/App/CameraSetting',
            icon: 'cil-puzzle'
          },  
          {
            name: '使用者編號查詢',
            to: '/App/UserSearch',
            icon: 'cil-puzzle'
          }, 
          {
            name: '手機掃描紀錄',
            to: '/App/PhoneScanner',
            icon: 'cil-puzzle'
          }, 
          {
            name: '網頁查詢紀錄',
            to: '/App/WebScanner',
            icon: 'cil-puzzle'
          },
          {
            name: '公眾號查詢紀錄',
            to: '/App/WeixinScanner',
            icon: 'cil-puzzle'
          },
          {
            name: '官網掃描紀錄',
            to: '/App/OfficialScanner',
            icon: 'cil-puzzle'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '操作紀錄查詢',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: '營運單位操作者記錄',
            to: '/OperateLog/Customer',
            icon: 'cil-puzzle'
          },  
          {
            name: '企業用戶操作者記錄',
            to: '/OperateLog/Enterprise',
            icon: 'cil-puzzle'
          }      
        ]
      },
    /*
      {
        _name: 'CSidebarNavDropdown',
        name: '系統參數及公司設定',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: '公司資料設定',
            to: '/Settings/OfficeData',
            icon: 'cil-puzzle'
          },  
          {
            name: '系統參數設定',
            to: '/Settings/SystemParams',
            icon: 'cil-puzzle'
          }      
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '用戶密碼權限設定',
        route: '',
        icon: 'cil-puzzle',
        items: [
          {
            name: '營運用戶資料管理',
            to: '/Users/User',
            icon: 'cil-puzzle'
          },  
          {
            name: '營運角色資料管理',
            to: '/Users/Role',
            icon: 'cil-puzzle'
          },  
          {
            name: '角色用戶指派',
            to: '/Users/AssignUser',
            icon: 'cil-puzzle'
          },  
          {
            name: '用戶角色指派',
            to: '/Users/AssignRole',
            icon: 'cil-puzzle'
          },  
          {
            name: '營運用戶密碼修改',
            to: '/Users/PwdChange',
            icon: 'cil-puzzle'
          },  
          {
            name: '企業用戶資料管理',
            to: '/Users/EnterpriseManager',
            icon: 'cil-puzzle'
          } 
        ]
      }
        */
    ],
  }
]